import store from '../store'
import PGSHelper from '../helpers/PGSHelper.js';

export default class Modificadores {
  static typeSearch = "local" //online || local
  static rules = {
    Nombre: [(value) => !!value || "El nombre es obligatorio"],
    Departamento: [(value) => !!value || "El departamento es obligatorio"],
  }

  constructor(data = null) {
    this.Id           = (data?.id)?data.id:null;
    this.Nombre       = (data?.Nombre) ? data.Nombre : '';
    this.Departamento = (data?.Departamento) ? data.Departamento : '';
    this.Tipo         = (data?.Tipo) ? data.Tipo : 'S';
    this.Opciones     = (data?.Opciones) ? data.Opciones : [];
    this.Dlat         = (data?.Dlat ) ? data.Dlat  : null;
  }

  static getRules() {
    return this.rules;
  }

  static getPropertyModel() {
    return this;
  }

  addOpcion(data){
    this.Opciones.push(data);
  }

  deleteOpcion(index){
    this.Opciones.splice(index, 1);
  }

  static parseToListOption(modificadores){
    let $pgsHelper = new PGSHelper();
    let opciones  = [];
    modificadores.forEach((modi)=>{
      modi.sel.forEach((seleccion)=>{
        opciones.push($pgsHelper.cloneObj(seleccion))
      })
    })
    return opciones
  }

}